import type { FetchUserAttributesOutput } from 'aws-amplify/auth'

export interface UserAttributes {
  sub: string
  email: string
  given_name: string
  family_name: string
  email_verified: string
  organization_id: string
  organization_name: string
}

export const convertUserAttributesListToLabels = (attributes: FetchUserAttributesOutput): UserAttributes => {
  const mapped: Record<string, string | undefined> = {}
  for (const [key, value] of Object.entries(attributes)) {
    const mappedKey =
      key === 'custom:organization_id'
        ? 'organization_id'
        : key === 'custom:organization_name'
        ? 'organization_name'
        : key
    mapped[mappedKey] = value
  }
  return mapped as unknown as UserAttributes
}
